module.exports = __webpack_public_path__ + "static/img/pin.013d587e.svg";